const CalculCategorie = (naissance) => {
    naissance = new Date(naissance)

    if(new Date('2013-09-01') < naissance) {
        return "U12"
    } else if(new Date('2009-09-01') < naissance) {
        return "U16"
    } else if(new Date('2005-09-01') < naissance) {
        return "U20"
    } else if(new Date('1975-09-01') < naissance) {
        return "OPEN"
    } else {
        return "VETERAN"
    }
}

export default CalculCategorie
